export const mainBlue = '#87CEFA';
export const mainPurple = '#7B68EE';
export const mainSkyBlue = '#05F3F3';
export const backgroundBlack = '#000A1F';
export const border = '#3A526E';
export const borderAngle = '#509AC8';
export const muiBorderColor = 'rgba(0, 0, 0, 0.23)';
